module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "id": "backtotop",
      "onclick": "scrollToTop();return false"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/back-to-top.png"
    }
  })]), _c('div', {
    staticClass: "footer-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "location"
  }, [_c('a', {
    attrs: {
      "href": "/wareham-office-location"
    }
  }, [_c('div', {
    staticClass: "map-img"
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/map-1.png"
    }
  })]), _c('div', {
    staticClass: "map-address"
  }, [_c('p', {
    staticClass: "phone"
  }, [_vm._v("(774) 678-0569")]), _vm._v("\t\t\t\t\t\t\t2421 Cranberry Highway, Suite 316"), _c('br'), _vm._v("                            Wareham, MA 02571")])])]), _c('div', {
    staticClass: "working_hours"
  }, [_c('div', {
    staticClass: "working_hours__title"
  }, [_vm._v("Working Hours:")]), _c('div', {
    staticClass: "working_hours__list"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("Monday")]), _c('td', [_vm._v("9 AM - 5 PM")])]), _c('tr', [_c('th', [_vm._v("Tuesday")]), _c('td', [_vm._v("9:30 AM - 6 PM")])]), _c('tr', [_c('th', [_vm._v("Wednesday")]), _c('td', [_vm._v("9 AM - 5 PM")])]), _c('tr', [_c('th', [_vm._v("Thursday")]), _c('td', [_vm._v("9:30 AM - 6 PM")])]), _c('tr', [_c('th', [_vm._v("Friday")]), _c('td', [_vm._v("Closed")])]), _c('tr', [_c('th', [_vm._v("Saturday")]), _c('td', [_vm._v("Closed")])]), _c('tr', [_c('th', [_vm._v("Sunday")]), _c('td', [_vm._v("Closed")])])])])]), _c('div', {
    staticClass: "foot-logo"
  }, [_c('a', {
    attrs: {
      "href": "/invisalign-info"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "alt": "invisalign",
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/invisalign.png"
    }
  })]), _c('a', {
    attrs: {
      "href": "https://www.mylifemysmile.org/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "alt": "aao",
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/aao.png"
    }
  })]), _c('a', {
    attrs: {
      "href": "https://www.ada.org/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "alt": "ada",
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/ada.png"
    }
  })])])])]), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer-menu"
  }, [_c('h5', [_vm._v("Browse")]), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/meet-dr-kevin-oliveira"
    }
  }, [_vm._v("About Us")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/office-visits"
    }
  }, [_vm._v("For New Patients")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/about-orthodontics"
    }
  }, [_vm._v("Wearing Braces")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/common-treatments"
    }
  }, [_vm._v("Treatments")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/invisalign-info"
    }
  }, [_vm._v("Invisalign")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/wareham-office-location"
    }
  }, [_vm._v("Contact Us")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://patient.sesamecommunications.com/koliveira/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Patient Login")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/sitemap"
    }
  }, [_vm._v("Site Map")])]), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")])])])]), _c('div', {
    staticClass: "footer-social"
  }, [_c('h5', [_vm._v("Connect")]), _c('ul', {
    staticClass: "social-icon"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/CoastalBraces",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/facebook.png",
      "alt": "Facebook"
    }
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://plus.google.com/u/0/103429814957908300625/about",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/google-plus.png",
      "alt": "Google Plus"
    }
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/coastal-orthodontics",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/linkedin.png",
      "alt": "Linked In"
    }
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=a8kk0aeUw90",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shift",
    attrs: {
      "src": "https://www.coastal-orthodontics.com/wp-content/uploads/2019/03/youtube.png",
      "alt": "YouTube"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0611bbc3","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 1259
// module chunks = 1